import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import "./DataPolicy.html";
import "./DataPolicy.scss";

import "./EditDataPolicy/EditSiteDataPolicySettingsComponent";

import DataPolicyComponentController from "./DataPolicyComponentController";

export default class DataPolicyComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            site: "<",
        };
        this.controller = DataPolicyComponentController;
        this.templateUrl = "/App/Components/Site/Overview/DataPolicy/DataPolicy.html";
    }
}

module("mmManagePortal").component("irSiteDataPolicy", new DataPolicyComponent());
